import { render, staticRenderFns } from "./ModalAjudaEditorNovo.vue?vue&type=template&id=4be67f6e&scoped=true&"
import script from "./ModalAjudaEditorNovo.vue?vue&type=script&lang=js&"
export * from "./ModalAjudaEditorNovo.vue?vue&type=script&lang=js&"
import style0 from "./ModalAjudaEditorNovo.vue?vue&type=style&index=0&id=4be67f6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be67f6e",
  null
  
)

export default component.exports